var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2917_152709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.66875L10.3313 0.75L6 5.08125L1.66875 0.75L0.75 1.66875L5.08125 6L0.75 10.3313L1.66875 11.25L6 6.91875L10.3313 11.25L11.25 10.3313L6.91875 6L11.25 1.66875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2917_152709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseModal);
export default __webpack_public_path__ + "static/media/ic-close-modal.5663e3a05fa4826419a3162ae0ab28b3.svg";
export { ForwardRef as ReactComponent };